import React from "react";

import LeaderboardPlayer from "custom-components/Project/Leaderboard/LeaderboardPlayer";
import LeaderboardPage from "components/Project/Leaderboard/LeaderboardPage";

/**
 * CUSTOM FOR GRAB:
 * - Display crown for Top 10 players
 */
class GrabLeaderboardPage extends LeaderboardPage {
  /**
   * Renders the leaderboard
   */
  renderBoard(board) {
    return (
      <div className="toppadding">
        {board.map((player, index) => (
          <LeaderboardPlayer
            key={player.id}
            id={player.id}
            projectId={this.props.projectId}
            userId={this.props.userId}
            rank={player.rank}
            userRankStatus={player.userRankStatus}
            userRankStatusImage={player.userRankStatusImage}
            name={player.name}
            points={player.points}
            image={player.photoLarge || player.image}
            self={
              this.props.board === "individual"
                ? player.id === this.props.userId
                : player.id === this.props.teamId
            }
            isTeam={this.props.board === "team"}
            language={this.props.language}
          />
        ))}
      </div>
    );
  }
}

export default GrabLeaderboardPage;
